"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var required_1 = require("./required");
function unpartial(arg1, arg2, arg3) {
    return required_1.required(arg1, arg2, arg3);
}
exports.unpartial = unpartial;
function unpartialRecursively(arg1, arg2, arg3) {
    return required_1.requiredDeep(arg1, arg2, arg3);
}
exports.unpartialRecursively = unpartialRecursively;
//# sourceMappingURL=unpartial.js.map